import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import compose from 'lodash/fp/compose';

import {
  takeEmployeesSearchQueriesFromLocation,
  takeEmployeesResetFormQueries,
  FORM_NAME_EMPLOYEES_SEARCH
} from 'src/reducers/searchForm';
import { saveEmployeeAttendanceSyncSetting } from 'src/reducers/settings/coordinations';
import SettingEmployeeSync from './components/SettingEmployeeSync';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

const mapStateToProps = state => ({
  initialValues: {
    ...takeEmployeesSearchQueriesFromLocation(state.router.location, true),
    ...getFormValues(FORM_NAME_EMPLOYEES_SEARCH)(state)
  },
  resetValues: takeEmployeesResetFormQueries(state, true),
  location: state.router.location,
  title: i18next.t('features.EmployeeAttendances.components.ActionSection.Staffs_attendance_link_setting')
});

const mapDispatchToProps = dispatch => ({
  saveEmployeeSyncSetting: () => dispatch(saveEmployeeAttendanceSyncSetting())
});

export default withTranslation('translation')(compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: FORM_NAME_EMPLOYEES_SEARCH,
    enableReinitialize: true
  })
)(SettingEmployeeSync));
